import React from 'react';

import {
  ActionButtonContainer,
  WidgetContainer,
  WidgetLabel,
  WidgetRow,
  WidgetSubtitle,
  WidgetTitle,
  WidgetValue,
} from './styles';
import ActionButton from '../../../components/ActionButton/ActionButton';
import { TranslationKeys } from '../../../../i18n/locales/defaultResources';
import { LieferanspruchWidgetProps } from './types';
import { useI18n } from '../../../../hooks/useI18n';
import {
  formatNumber,
  mapLocaleAccordingToNzRules,
} from '../../../../helpers/localeFormatter';

const LieferanspruchWidget: React.FC<LieferanspruchWidgetProps> = ({
  countryIsoCode,
  data,
  onMoreInfoClick,
}) => {
  const { t } = useI18n();
  const mappedCountry = mapLocaleAccordingToNzRules(countryIsoCode);

  return (
    <WidgetContainer>
      <WidgetTitle>
        {t(TranslationKeys.lieferanspruch_widget_title)} {data.year}
      </WidgetTitle>
      <WidgetSubtitle>
        {t(TranslationKeys.lieferanspruch_widget_subtitle)}
      </WidgetSubtitle>
      <WidgetRow>
        <WidgetLabel>
          {t(TranslationKeys.lieferanspruch_widget_total_entitlement)}
        </WidgetLabel>
        <WidgetValue>
          {formatNumber(data.deliveryEntitlementTotal, mappedCountry)} T
        </WidgetValue>
      </WidgetRow>
      <WidgetRow>
        <WidgetLabel>
          {t(TranslationKeys.lieferanspruch_widget_contracted_amount)}
        </WidgetLabel>
        <WidgetValue>
          {formatNumber(data.contractedAmount, mappedCountry)} T
        </WidgetValue>
      </WidgetRow>
      <WidgetRow>
        <WidgetLabel>
          {t(TranslationKeys.lieferanspruch_widget_available_amount)}
        </WidgetLabel>
        <WidgetValue>
          {formatNumber(data.availableAmount, mappedCountry)} T
        </WidgetValue>
      </WidgetRow>
      <ActionButtonContainer>
        <ActionButton
          variant="link-button"
          buttonText={t(TranslationKeys.lieferanspruch_widget_more_info)}
          onClickAction={onMoreInfoClick}
        />
      </ActionButtonContainer>
    </WidgetContainer>
  );
};

export default LieferanspruchWidget;
